import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/discord': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M297.2 243.2c0 15.6-11.5 28.4-26.1 28.4-14.3 0-26.1-12.8-26.1-28.4s11.5-28.4 26.1-28.4c14.6 0 26.1 12.8 26.1 28.4zM177.7 214.8c14.6 0 26.4 12.8 26.1 28.4 0 15.6-11.5 28.4-26.1 28.4-14.3 0-26.1-12.8-26.1-28.4s11.5-28.4 26.1-28.4zM448 52.7v459.3c-64.5-57-43.9-38.1-118.8-107.8l13.6 47.4h-290.3c-28.9 0-52.5-23.6-52.5-52.7v-346.1c0-29.2 23.6-52.7 52.5-52.7h343c28.9 0 52.5 23.6 52.5 52.7zM375 295.4c0-82.4-36.9-149.2-36.9-149.2-36.9-27.6-71.9-26.9-71.9-26.9l-3.6 4.1c43.5 13.3 63.7 32.5 63.7 32.5-60.8-33.3-132.2-33.3-191.2-7.4-9.5 4.4-15.1 7.4-15.1 7.4s21.2-20.2 67.3-33.5l-2.6-3.1s-35.1-0.8-71.9 26.9c0 0-36.9 66.8-36.9 149.2 0 0 21.5 37.1 78.1 38.9 0 0 9.5-11.5 17.2-21.2-32.5-9.7-44.8-30.2-44.8-30.2 3.8 2.6 10 6.1 10.5 6.4 43.2 24.2 104.6 32.1 159.7 9 9-3.3 18.9-8.2 29.4-15.1 0 0-12.8 21-46.3 30.5 7.7 9.7 16.9 20.7 16.9 20.7 56.6-1.8 78.3-38.9 78.3-38.9z'
      }
    ]
  }
})
